import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "@/store/types";

export const getTimekeepingState = (state: RootState) => state.timekeeping;

export function getTeams() {
  return createSelector([getTimekeepingState], state => state.teams);
}

export function getCheckInData() {
  return createSelector([getTimekeepingState], state => state.checkIn);
}

export function getSelectedCheckInDetail() {
  return createSelector([getTimekeepingState], state => state.selectedCheckInDetail);
}

export function getSelectedCheckInItem() {
  return createSelector([getTimekeepingState], state => state.selectedCheckInItem);
}

export function getCheckInPhoto() {
  return createSelector([getTimekeepingState], state => state.checkInPhoto);
}